import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { SlideTransition } from '../../../components/Transition/Transition';

const EmergencyEWalletShareAddToWalletDialog = props => {
  const { intl, open, onClose } = props;

  return (
    <Dialog open={open} fullWidth={true} slots={{
      transition: SlideTransition
    }}>
      <DialogTitle>{intl.formatMessage({ id: 'emergency-e-wallet-share-add-to-wallet' })}</DialogTitle>
      <DialogContent>{intl.formatMessage({ id: 'emergency-e-wallet-add-to-wallet-content' })}</DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {intl.formatMessage({ id: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(EmergencyEWalletShareAddToWalletDialog);
